<template>
  <div v-if="form && mounted" class="admin-page">
    <h1>Edit Group data: {{group?.customerName}}</h1>

    <form @submit.prevent="save">
      <div v-if="errors.general" class="form-error">{{ errors.general }}</div>
      <div v-if="errors['']" class="form-error">{{ errors[''] }}</div>

      <div class="form-field ">
        <div class="checkbox-group">
          <div>
            <input id="consent" type="checkbox" v-model="form.consent"/>
            <label for="consent">consent</label>
            <div v-if="errors.consent" class="form-error">{{ errors.consent }}</div>
          </div>
        </div>
      </div>

      <button type="submit">Save Group</button>
    </form>
  </div>
</template>

<script setup lang="ts">
import {onMounted, ref} from 'vue';
import {type DBGHubPayload, EntityType, type GroupMetaValues, type GroupSummary} from "@/data";
import {ValueService} from "@/services";
import {useRoute, useRouter} from "vue-router";

const route = useRoute();
const router = useRouter();

const form = ref<GroupMetaValues>();
const group = ref<DBGHubPayload | null>();
const errors = ref<Record<string, string>>({});
const mounted = ref(false);

const groupId = route.params.groupId as string;

const service = new ValueService()

onMounted(async () => {
  group.value = await service.loadValueData(EntityType.GROUP, groupId);
  if (group.value) {
    const meta = await service.fetchGroupMetadata(groupId!);
    form.value = JSON.parse(JSON.stringify(meta || {consent: false}));
  } else {
    console.error('Group not found');
    router.push({name: "404"});
  }
  mounted.value = true;
});

const save = async () => {
  errors.value = {};
  try {
    if (!form.value) return;

    await service.saveGroupMetadata(groupId, form.value);
    router.push("/benefits");
  } catch (error: any) {
    errors.value.general = error.message || 'An error occurred';
    if (error.errors) {
      for (const [key, msg] of Object.entries(error.errors)) {
        errors.value[key] = msg as string;
      }
    }
  }
};
</script>

<style scoped src="../admin.css">
</style>